'use strict';

namespace Core {

    class NewsFlash {

        dismissable : boolean;
        text : string;
        isDismissed : boolean = false;

        constructor(private $element:JQuery, private cookieService:any){

            this.isDismissed = this.cookieService.get('newsflash') !== null;
        }

        onClosed() {
            this.$element.slideUp();
            this.persist();
        }

        persist() {
            this.cookieService.set('newsflash', 'dismissed');
        }
    }

    angular
        .module('core')
        .directive('newsflash', (cookieService) => {
            return {
                restrict: 'A',
                replace: true,
                transclude: true,
                controller: NewsFlash,
                controllerAs: 'nf',
                scope : {},
                bindToController: {
                    dismissable :'@',
                    text : '@'
                },
                templateUrl: 'partials/home/directivetemplate?type=Newsflash'
            };
        });

}
